export class PickingListParams {
    page = 1;
    limit = 10;
    search?: string;
    status?: number;
    type?: number;
    purpose?: number;
    postOfficeRowGuid?: string;
}

export class HistoryStockOutParams {
    page = 1;
    limit = 10;
    pickingListType?: number;
    pickingListCode?: string;
    deliveryEmployeeRowGuid?: string;
    fromDate?: number;
    toDate?: number;
}
